// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3qKcG","overflowing":"ReadFullNote_overflowing__28LHq"};